import { Template } from "../../../../../core/entities/template";
import React, { useEffect, useState } from "react";
import { ReplacementField } from "../../../../../core/entities/replacementField";
import { useServiceContext } from "../../../../../contexts/ServiceContext";
import { LoadingComponent } from "../../../../components/state/Loading";

interface Props {
    selected: Template;
    replacementFields?: ReplacementField[];
    height?: number | null;
    width?: number | null;
}

function replaceContent(
    content: string,
    replacementFields: ReplacementField[]
): string {
    let temp = content;
    for (const rf of replacementFields) {
        temp = temp.replaceAll(rf.key, rf.value);
    }

    return temp;
}

export function TemplatePdfView({
    selected,
    replacementFields,
    width = null,
    height = null
}: Props) {
    const {
        htmlToPdfService: { parse }
    } = useServiceContext();
    if (!width) {
        width = 536;
    }

    if (!height) {
        height = 800;
    }

    const [pdfBase64, setPdfBase64] = useState<string>();
    const [selectedLoaded, setSelectedLoaded] = useState<number>();
    const [loading, setLoading] = useState(true);

    async function loadPdf() {
        if (selectedLoaded === selected.id) {
            return;
        }
        const replacedContent = replacementFields
            ? replaceContent(selected.framedContent, replacementFields)
            : selected.framedContent;
        parse(replacedContent).then((x) =>
            setPdfBase64("data:application/pdf;base64," + x)
        );
        setSelectedLoaded(selected.id);
    }

    useEffect(() => {
        loadPdf().then();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    function onDoneLoading() {
        setLoading(false);
    }

    return (
        <div className={"flex items-center"}>
            {loading && (
                <div>
                    <LoadingComponent></LoadingComponent>
                </div>
            )}
            {pdfBase64 && (
                <>
                    <iframe
                        title={"Pdf af kvitterings skabelon"}
                        src={pdfBase64}
                        width={width}
                        height={height}
                        onLoad={onDoneLoading}
                    ></iframe>
                </>
            )}
        </div>
    );
}
